"use client";

import { useTranslation } from "react-i18next";

import { ScrollArea } from "@/components/ui/scroll-area";
import { DashboardHeader } from "@/features/workspaces/components/workspace-dashboard/DashboardHeader";
import { DashboardCarousel } from "@/features/workspaces/components/workspace-dashboard/DashboardCarousel";
import { WorkspacesList } from "@/features/workspaces/components/workspace-dashboard/WorkspacesList";
import { NextLessonCard } from "@/features/workspaces/components/workspace-dashboard/NextLessonCard";
import { HomeworkCard } from "@/features/workspaces/components/workspace-dashboard/HomeworkCard";
import { NotificationsCard } from "@/features/workspaces/components/workspace-dashboard/NotificationsCard";
import { AttendanceCard } from "@/features/workspaces/components/workspace-dashboard/AttendanceCard";
import { CoachMarker } from "@/components/CoachMarker.tsx";

export default function TutorWorkspaceDashboard() {
  const { t } = useTranslation(["sidebar", "help"]);

  return (
    <>
      <title>{`${t("tutor.overview")} - Ximly`}</title>
      <div className="bg-background min-h-[calc(100dvh_-_4rem)]">
        <ScrollArea className="h-[calc(100dvh_-_4rem)]">
          <div className="mx-auto max-w-7xl p-3 sm:p-4 lg:p-6">
            <CoachMarker
              description={t("help:coachMarkers.dashboard.header.tutor.description" as any)}
              id="dashboard-header"
              placement="bottom"
              title={t("help:coachMarkers.dashboard.header.tutor.title" as any)}
            >
              <DashboardHeader />
            </CoachMarker>
            {/* Carousel */}
            <DashboardCarousel />
            {/* Main Grid */}
            <div className="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-10">
              {/* Left Column - Workspaces and Attendance */}
              <div className="space-y-4 sm:space-y-6 lg:col-span-3">
                <CoachMarker
                  description={t("help:coachMarkers.dashboard.workspaces.description" as any)}
                  id="dashboard-workspaces-list"
                  placement="right"
                  title={t("help:coachMarkers.dashboard.workspaces.title" as any)}
                >
                  <WorkspacesList />
                </CoachMarker>
                <AttendanceCard />
              </div>

              {/* Middle Column - Main Content */}
              <div className="space-y-4 sm:space-y-6 lg:col-span-7">
                <CoachMarker
                  description={t("help:coachMarkers.dashboard.nextLesson.description" as any)}
                  id="dashboard-next-lesson"
                  placement="bottom"
                  title={t("help:coachMarkers.dashboard.nextLesson.title" as any)}
                >
                  <NextLessonCard />
                </CoachMarker>
                <CoachMarker
                  description={t("help:coachMarkers.dashboard.tasks.tutor.description" as any)}
                  id="dashboard-tasks-grid"
                  placement="bottom"
                  title={t("help:coachMarkers.dashboard.tasks.tutor.title" as any)}
                >
                  <div className="grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2">
                    <HomeworkCard />
                    <NotificationsCard />
                  </div>
                </CoachMarker>
              </div>
            </div>
          </div>
        </ScrollArea>
      </div>
    </>
  );
}
